import { BLOCKED_EVENT_DATA_FIELD_KEYS } from './blockedEventDataFieldKeys';
import { CALCULATION_DATA_FIELD_KEYS } from './calculationDataFieldKeys';
import { EVENT_DATA_FIELD_KEYS } from './eventDataFieldKeys';
import { METRIC_DATA_FIELD_KEYS } from './metricDataFieldKeys';

export * from './customEventDataFieldKey';
export * from './customCalculationDataFieldKey';
export * from './cohortsDataFieldKeys';
export * from './dynamicCalculationDataFieldKey';

export { EVENT_DATA_FIELD_KEYS, BLOCKED_EVENT_DATA_FIELD_KEYS, METRIC_DATA_FIELD_KEYS, CALCULATION_DATA_FIELD_KEYS };

export const DATA_FIELD_KEYS = {
  ...EVENT_DATA_FIELD_KEYS,
  ...BLOCKED_EVENT_DATA_FIELD_KEYS,
  ...METRIC_DATA_FIELD_KEYS,
  ...CALCULATION_DATA_FIELD_KEYS,
} as const;

export const DATA_FIELD_KEY_SEPARATOR = '__';
